import { render, staticRenderFns } from "./organization-selector.vue?vue&type=template&id=e52f9870&scoped=true"
import script from "./organization-selector.vue?vue&type=script&lang=js"
export * from "./organization-selector.vue?vue&type=script&lang=js"
import style0 from "./organization-selector.vue?vue&type=style&index=0&id=e52f9870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52f9870",
  null
  
)

export default component.exports